import { api } from "@/frontend/services/api";
import type {
  ApiResponse,
  CreateTournamentGroupRequestDTO,
  TournamentGroupResponseDTO,
  TournamentGroupsPaginatedResponseDTO,
  TournamentGroupQueryDTO,
} from "@/shared/dto";

const BASE_URL = "/tournament-groups/private";

interface AdvanceGroupRequest {
  seasonId: string;
}

interface AdvanceGroupResponse {
  success: boolean;
  advancedParticipants: Array<{
    participantId: string;
    participantName: string | null;
    groupName: string | null;
    rank: number | null;
    slotKey: string | null;
  }>;
  message: string;
}

export const tournamentGroupService = {
  getPaginate: (params?: Partial<TournamentGroupQueryDTO>) =>
    api.getWithParams<ApiResponse<TournamentGroupsPaginatedResponseDTO>>(BASE_URL, params),
  getByStageId: (stageId: string) =>
    api.get<ApiResponse<TournamentGroupResponseDTO[]>>(`${BASE_URL}/stage/${stageId}`),
  create: (data: CreateTournamentGroupRequestDTO) =>
    api.post<ApiResponse<TournamentGroupResponseDTO>>(BASE_URL, data),
  advanceGroup: (groupId: string, data: AdvanceGroupRequest) =>
    api.post<ApiResponse<AdvanceGroupResponse>>(`${BASE_URL}/${groupId}/advance`, data),
  advanceAllGroups: (data: AdvanceGroupRequest) =>
    api.post<ApiResponse<AdvanceGroupResponse>>(`${BASE_URL}/advance`, data),
};
